
import { DashboardPage } from "../../components/layout/dashboardPage";
import { Col } from "../../style/base.style";
import { Colors } from "../../style/colors";
import { Appointments } from "../../components/dashboard/appointments";
import { Cases } from "../../components/dashboard/cases";

export const DashboardCases:React.FC = () => {

  
    return (
      <DashboardPage title="appointments">
        <Col $width="100%" $justifyContent="flex-start" $alignItems="flex-start" $backgroundColor={Colors.whiteBackground} $padding="20px" $border={`1px solid ${Colors.fieldBorder}`} $borderRadius={10}>
         <Cases/>
        </Col>
        
          
      </DashboardPage>
        
    )
}